import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { AppAsyncThunkAPI } from '../..';
import { getMemberWatercrafts } from '../../../member/profile';
import { selectCurrentMemberId } from '../backend-service';
import { Vessel } from './models';

export const setBackRoute = createAction('VESSELS_SET_BACK_ROUTE', (route) => ({
  payload: route,
}));
export const resetBackRoute = createAction('VESSELS_RESET_BACK_ROUTE');

export const setVessels = createAction(
  '[Vessels] set member vessels',
  (vessels: Vessel[]) => ({
    payload: vessels,
  }),
);

export const resetVesselsState = createAction('[Vessels] reset');

export const setSelectedVessel = createAction(
  '[Vessels] set selected vessel',
  (id: Vessel['id']) => ({
    payload: id,
  }),
);

export const clearSelectedVessel = createAction(
  '[Vessels] clear selected vessel',
);

export const fetchVesselsForCurrentMember = createAsyncThunk<
  void,
  void,
  AppAsyncThunkAPI
>(
  '[Vessels] fetch vessels for current member',
  async (_, { getState, rejectWithValue, dispatch }) => {
    const state = getState();

    const currentMemberId = selectCurrentMemberId(state);

    if (!currentMemberId) {
      rejectWithValue('No member id found');
      return;
    }

    let vessels: Vessel[];
    try {
      vessels = await getMemberWatercrafts(currentMemberId);
    } catch (e: any) {
      rejectWithValue(e.message);
      return;
    }

    await dispatch(setVessels(vessels));
  },
);
